import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import media from '@Styles/media'
import Link from 'next/link'
import { HubLink } from 'src/common/rtl/HubWidgets'

@observer
export class Links extends Component {
  render() {
    const { links, appStyles, ...rest } = this.props
    if (!links) return null

    return (
      <Ul {...rest}>
        {links.map((link, idx) => (
          <Li key={`link-${idx}`} {...rest}>
            <Link href={link.href} prefetch={false}>
              <StyledLink
                href={link.href}
                appStyles={appStyles}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.title}
              </StyledLink>
            </Link>
          </Li>
        ))}
      </Ul>
    )
  }
}

const Ul = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  ${({ isPartOfFooter }) =>
    isPartOfFooter &&
    media.smallScreen`
    justify-content: center;
    box-shadow: none;
  `}
  ${({ isPartOfFooter }) =>
    isPartOfFooter &&
    media.mediumScreen`
    justify-content: center;
    box-shadow: none;
  `}
`

const Li = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grayDark};
  font-size: ${({ theme }) => theme.fontSizes.fontSizeSmaller};
  letter-spacing: 0.4px;
  padding: 0 20px;
  position: relative;
  height: 30px;
  margin: ${({ theme }) => theme.sizes.gutterSmaller} 0;
  border-right: 1px solid ${({ theme }) => theme.colors.grayLight};

  &:last-child {
    border: none;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.grayDarker};
    cursor: pointer;
  }

  ${media.smallScreen`
    font-size: 0.9rem;
    padding: 0 14px;
  `}

  ${media.mediumScreen`
    font-size: 0.9rem;
    padding: 0 14px;
  `}
`

const StyledLink = styled(HubLink)`
  color: ${({ appStyles }) => appStyles.hubAccentColor};
  box-shadow: none;

  &:hover {
    color: lighten(0.2, ${({ appStyles }) => appStyles.hubAccentColor});
  }
`

export default Links
